import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import Font from '../font';

function hasHeadlineOptions(model) {
  return getRecordType(model) === 'content-item' && !model.isLayoutModule;
}

<template>
  <@form.fieldset
    @titleKey='headline'
    @isClosed={{true}}
    @showSelectedAttributesIndicator={{true}}
    as |fieldset|
  >
    {{#if (hasHeadlineOptions @form.model)}}
      <fieldset.field @property='options.headline' />
      <fieldset.field @property='options.headlineHide' @type='checkbox' />
    {{/if}}

    <Font
      @fieldset={{fieldset}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
      @prefix='headlineFont'
    />
    <fieldset.field @property='options.headlineFontColor' @type='color' />
  </@form.fieldset>
</template>
